/**
 * @format
 * @Description: job实例状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Utils from 'utils';
import { message } from 'antd';
import { get } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class JobManageMod {
  @observable
  version = 0;

  @observable
  form = {};

  @observable
  addManageVisible = false;

  @observable
  chooseTaskVisible = false;

  @observable
  isEdit = false;

  @observable
  editInfo = {};

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }

  getJobListBeforeRequest = data => {
    const { status, bizName, appCode } = data;
    return {
      pageSize: data.pageSize,
      pageNum: data.pageNum,
      filter: {
        appCode,
        bizName,
        status,
        startTime: data.updateTime && data.updateTime[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: data.updateTime && data.updateTime[1].format('YYYY-MM-DD HH:mm:ss')
      }
    };
  };
  getTaskListBeforeRequest = data => {
    const { bizName, appCode } = data;
    let startTime;
    let endTime;
    startTime = get(data, ['updateTime', '0', '_d']) ? Utils.timeFormat(get(data, ['updateTime', '0', '_d'])) : '';
    endTime = get(data, ['updateTime', '1', '_d']) ? Utils.timeFormat(get(data, ['updateTime', '1', '_d'])) : '';
    return {
      pageSize: data.pageSize,
      pageNum: data.pageNum,
      filter: {
        bizName,
        status: 'ENABLE',
        startTime,
        endTime,
        appCode
      }
    };
  };
  chooseTask = data => {
    if (data.keys.length) {
      this.form.setFieldsValue({ bizName: data.rows[0].bizName });
      this.form.setFieldsValue({ paramsDesc: data.rows[0].paramsDesc });
      let editInfo = JSON.parse(JSON.stringify(this.editInfo));
      editInfo.appBizId = data.keys[0];
      this.updateStore({ editInfo, chooseTaskVisible: false });
    } else {
      message.warn('必须选择一个Task');
    }
  };
  saveFormBeforeRequest = data => {
    data.appBizId = this.editInfo.appBizId;
    return data;
  };
}

// ES6单例写法
export default new JobManageMod();



// WEBPACK FOOTER //
// ./src/pages/DispatchCenter/JobManage/JobManageMod.js